/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View, TouchableOpacity, StyleProp, ViewStyle } from "react-native";
import { ic_work } from "react-icons-kit/md/ic_work";
import { ic_mail } from "react-icons-kit/md/ic_mail";
import { ic_place } from "react-icons-kit/md/ic_place";

import { useSelector } from "react-redux";

import { ProfileImage, Text } from "UpduoLibrary";
import {
  dashboardStyles,
  DashboardWidgetItem,
  Divider,
} from "./shared_components";
import { upduoPrimaryBlue } from "config/UpduoColors";
import { RootState } from "store/types";

export default function UserDashboardWidget({
  style,
  setShowSettings,
}: {
  style?: StyleProp<ViewStyle>;
  setShowSettings: (boolean) => void;
}) {
  const selfObject = useSelector((state: RootState) => state.selfObject);

  const userInfo = [
    {
      icon: ic_work,
      value: selfObject.title,
    },
    {
      icon: ic_place,
      value: selfObject.storeName,
    },
  ];

  return (
    <View style={[dashboardStyles.dashboardWidget, style]}>
      <View
        style={{
          display: "flex",
          flexDirection: "column",
          padding: 20,
          alignItems: "stretch",
        }}
      >
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Text style={dashboardStyles.widgetTitle}>{"Profile"}</Text>

          <TouchableOpacity
            onPress={() => {
              setShowSettings(true);
            }}
          >
            <Text
              style={{
                color: upduoPrimaryBlue,
                fontSize: 14,
              }}
            >
              {"edit"}
            </Text>
          </TouchableOpacity>
        </View>

        <ProfileImage
          style={{
            alignSelf: "center",
            marginVertical: 20,
          }}
          userObject={selfObject}
          size={100}
        />
        <Text
          isHeading={true}
          style={[
            dashboardStyles.widgetTitle,
            {
              textAlign: "center",
            },
          ]}
        >
          {selfObject.firstName} {selfObject.lastName}
        </Text>
      </View>
      <Divider />

      <View style={{ paddingVertical: 15 }}>
        <DashboardWidgetItem
          text={selfObject.primaryEmail}
          icon={ic_mail}
          border={"none"}
          styles={{ paddingVertical: 0 }}
        />
        {userInfo.map((info, i) =>
          info.value ? (
            <DashboardWidgetItem
              text={info.value}
              icon={info.icon}
              border={"none"}
              key={i}
              styles={{ paddingVertical: 0, paddingTop: 8 }}
            />
          ) : null
        )}
      </View>
    </View>
  );
}
